import React, { useState } from "react";
import "./topBar.scss";
import { FaBars, BsPerson, VscMail } from "react-icons/all";

export default function TopBar({ menuOpen, setMenuOpen }) {
  // console.log(propFunctions);
  // const [menuOpen, setMenuOpen] = useState(false);
  return (
    <>
      <div className={`${menuOpen ? "topbar active" : "topbar"}`}>
        <div className="wrapper">
          <div className="left">
            <a href="#intro" className="logo">
              ME
            </a>
            <div className="itemContainer">
              <BsPerson className="icon" />
              <span>3434334343</span>
            </div>
            <div className="itemContainer">
              <VscMail className="icon" />
              <span>randima@gmail.com</span>
            </div>
          </div>
          <div className="right">
            <div
              className="hamburger"
              onClick={() => {
                setMenuOpen(!menuOpen);
                // menuOpen ? setMenuOpen(false) : setMenuOpen(true);
              }}
            >
              <span className="line1"></span>
              <span className="line2"></span>
              <span className="line3"></span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
